import type { SVGProps } from 'react';

const SvgFoldLeftMd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M8.3457 7L4.3457 12M4.3457 12L8.3457 17M4.3457 12L14.3457 12M20.3457 5L20.3457 19'
      stroke='currentColor'
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
export default SvgFoldLeftMd;
